import React from 'react';
import { browserHistory } from 'react-router';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { isUndefinedNullOrEmpty } from '../../../js/utils';
import { asyncronousOperationStatuses } from '../../../js/statuses';
import { reliablyHandleFormSubmit } from '../../common/formUtils';
import { setSourceLocation } from '../../../js/actions/imagingWorkflowActionCreators';
import { fetchInstanceDetails } from '../../../js/actions/sqlServerInstanceActionCreators';
import selectionElementMode from '../../common/selectionElementMode';
import { TextareaFieldWithValidation } from '../../common/FormComponents';
import SelectWithValidation from '../../common/SelectWithValidation';
import SqlServerInstanceSelection from '../../common/SqlServerInstanceSelection';
import FormErrorNotification from '../../common/FormErrorNotification';
import InlineValidationMessage from '../../common/InlineValidationMessage';
import BackupLocationSelection from '../../common/BackupLocationSelection';
import BackLink from '../../common/BackLink';

const validateForBackup = (values) => {
    const errors = {};

    if (isUndefinedNullOrEmpty(values.backupLocation)) {
        errors.backupLocation = 'Specify a base backup location';
    }

    if (isUndefinedNullOrEmpty(values.backupFileLocations)) {
        errors.backupFileLocations = 'Specify at least one backup file';
    }

    return errors;
};

const validateForDatabase = (values) => {
    const errors = {};

    if (isUndefinedNullOrEmpty(values.sqlServerInstance)) {
        errors.sqlServerInstance = 'Select a SQL server instance';
    }

    if (isUndefinedNullOrEmpty(values.databaseOnInstance)) {
        errors.databaseOnInstance = 'Select a source database';
    }

    return errors;
};

const validate = (values) => {
    return values.isBackupView
        ? validateForBackup(values)
        : validateForDatabase(values);
};

const getInstanceFullNameForBackupLocation = (backupLocationId, backupLocations, sqlServerInstances) => {
    if (isUndefinedNullOrEmpty(backupLocationId)) { return null; };

    const backupLocation = backupLocations.get(backupLocationId);
    if (isUndefinedNullOrEmpty(backupLocation) || isUndefinedNullOrEmpty(backupLocation.temporaryInstanceId)) { return null; };

    const sqlServerInstance = sqlServerInstances.get(backupLocation.temporaryInstanceId);
    if (isUndefinedNullOrEmpty(sqlServerInstance)) { return null; };

    return sqlServerInstance.server + '\\' + sqlServerInstance.instance;
};

const renderBackupLocationSelectionField = (props) => {
    return <div>
        <BackupLocationSelection value={props.input.value} autoFocus={props.autoFocus} onChange={props.input.onChange} onModeChanged={props.onModeChanged} />
        <InlineValidationMessage touched={props.meta.touched} error={props.meta.error} />
    </div>;
};

const renderServerSelectionField = (props) => {
    return <div>
        <SqlServerInstanceSelection labelText="Source SQL Server Instance" value={props.input.value} onChange={props.input.onChange} onModeChanged={props.onModeChanged} autoFocus={props.autoFocus} />
        <InlineValidationMessage touched={props.meta.touched} error={props.meta.error} />
    </div>;
};

const DatabaseSelectionField = React.createClass({
    componentWillReceiveProps: function(nextProps) {
        const oldServerId = this.props.sqlServerInstanceId;
        const newServerId = nextProps.sqlServerInstanceId;

        if(oldServerId !== newServerId) {
            this.props.input.onChange(null);
        }
    },
    render: function() {
        const { items, isLoading, loadingError, placeholder, label, meta, input } = this.props;
        return <SelectWithValidation items={items}
            isLoading={isLoading} 
            loadingError={loadingError} 
            placeholder={placeholder}
            label={label}
            input={input}
            meta={meta} />;
    }
});

const ImageSourceLocationForm = React.createClass({
    getInitialState: function () {
        return {
            isOnSqlServerInstanceAddMode: false,
            isOnBackupLocationAddMode: false
        };
    },
    componentWillReceiveProps: function (nextProps) {
        const { updateableDetailsForInstance, selectedServerInstance } = this.props;

        if (selectedServerInstance !== nextProps.selectedServerInstance) {
            this.props.onFetchDatabasesForServerInstance(nextProps.selectedServerInstance);
        }
    },
    onSqlServerSelectionModeChanged: function (mode) {
        this.setState({ isOnSqlServerInstanceAddMode: mode === selectionElementMode.add });
    },
    onBackupLocationSelectionModeChanged: function (mode) {
        this.setState({ isOnBackupLocationAddMode: mode === selectionElementMode.add });
    },
    render: function () {
        const {
            initialValues: { isBackupView },
            handleSubmit,
            setDatabaseSourceLocation,
            setBackupSourceLocation,
            updateableDetailsForInstance,
            error,
            selectedServerInstance,
            selectedBackupLocation,
            sqlServerInstances,
            backupLocations,
            pristine,
            submitting,
            valid
        } = this.props;

        const { isOnSqlServerInstanceAddMode, isOnBackupLocationAddMode } = this.state;
        const isServerInstanceSelected = !isUndefinedNullOrEmpty(selectedServerInstance);
        const isBackupLocationSelected = !isUndefinedNullOrEmpty(selectedBackupLocation);
        const selectedInstanceDetails = updateableDetailsForInstance.get(selectedServerInstance);
        const isSelectedInstanceDetailsAvailable = !isUndefinedNullOrEmpty(selectedInstanceDetails);
        const isDatabaseListAvailable = isSelectedInstanceDetailsAvailable && !isUndefinedNullOrEmpty(selectedInstanceDetails.databaseNames);
        const databasesLoadingError =  (isSelectedInstanceDetailsAvailable && selectedInstanceDetails.updateStatus === asyncronousOperationStatuses.failure) ?
            'An error occurred while loading the list of databases - switch SQL Server instances to try again' :
            null;

        const databaseItemsForSelectedInstance = (isSelectedInstanceDetailsAvailable && isDatabaseListAvailable) ?
            selectedInstanceDetails.databaseNames.map(dbName => ({ id: dbName, value: dbName })) :
            null;

        const instanceNameForSelectedBackupLocation = getInstanceFullNameForBackupLocation(selectedBackupLocation, 
            backupLocations, sqlServerInstances);

        const onValid = (data) => {
            return reliablyHandleFormSubmit(() => {
                if (data.isBackupView) {
                    setBackupSourceLocation({
                        id: data.backupLocation,
                        friendlyName: backupLocations.get(data.backupLocation).backupBasePath,
                        resourceNames: data.backupFileLocations.split('\n')
                    });
                } else {
                    setDatabaseSourceLocation({
                        id: data.sqlServerInstance,
                        friendlyName: sqlServerInstances.get(data.sqlServerInstance).instance,
                        resourceNames: [data.databaseOnInstance]
                    });
                }

                browserHistory.push('/images/create/destination');
            });
        };

        return <form onSubmit={handleSubmit(onValid)}>
            <div>
                <div className="form-container">
                    <FormErrorNotification error={error} />

                    <BackLink />
                    {!isBackupView && <div>
                        {!isOnSqlServerInstanceAddMode && <h1>Source database</h1>}
                        <div className="control-holder">
                            <Field name="sqlServerInstance" placeholder="Select a server instance" autoFocus onModeChanged={this.onSqlServerSelectionModeChanged} component={renderServerSelectionField} />
                        </div>

                        {(!isOnSqlServerInstanceAddMode && isServerInstanceSelected) && <div className="control-holder">
                            <Field name="databaseOnInstance" label="Database" 
                                placeholder="Select a database" items={databaseItemsForSelectedInstance} sqlServerInstanceId={selectedServerInstance} 
                                isLoading={!isDatabaseListAvailable} loadingError={databasesLoadingError} component={DatabaseSelectionField} />
                        </div>}
                    </div>}

                    {isBackupView && <div>
                        {!isOnBackupLocationAddMode && <h1>Backup location</h1>}
                        <div className="control-holder">
                            <Field name="backupLocation" placeholder="Select a backup location" autoFocus onModeChanged={this.onBackupLocationSelectionModeChanged} component={renderBackupLocationSelectionField} />
                        </div>
                        {(!isOnBackupLocationAddMode && isBackupLocationSelected) && <div className="control-holder">
                            {instanceNameForSelectedBackupLocation && <div>
                                <label>SQL Server instance</label>
                                <input type="text" value={instanceNameForSelectedBackupLocation} readOnly/>
                                <p className="small">This SQL Server instance will be used to temporarily restore the backup.<br />
                                The image can be used to create clones on SQL Server instances of this version or newer.</p>
                            </div> }
                            <Field name="backupFileLocations" type="text" label="Backup file name(s)" placeholder="e.g. mydb\mydb_20160707_111931.sqb" component={TextareaFieldWithValidation} />
                            <p className="small">Enter paths to .sqb or .bak files relative to the folder.<br />
                            For striped backups, add one path per line.</p>
                        </div>}
                    </div>}

                    {(!isOnSqlServerInstanceAddMode && !isOnBackupLocationAddMode && valid && !pristine) &&
                        <button type="submit" className="button button--primary" disabled={submitting}>
                            Next
                        </button>}
                </div>
            </div>
        </form>;
    }
});

const formName = 'ImageSourceLocationForm';
const selector = formValueSelector(formName);

function mapStateToProps(state) {
    return {
        backupLocations: state.backupLocations.value,
        sqlServerInstances: state.sqlServerInstances.value,
        updateableDetailsForInstance: state.instanceDetails,
        imageCreation: state.app.imageCreation,
        selectedServerInstance: selector(state, 'sqlServerInstance'),
        selectedBackupLocation: selector(state, 'backupLocation')
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onFetchDatabasesForServerInstance: (sqlServerInstance) => {
            dispatch(fetchInstanceDetails(sqlServerInstance));
        },
        setDatabaseSourceLocation: (location) => {
            dispatch(setSourceLocation(location));
        },
        setBackupSourceLocation: (location) => {
            dispatch(setSourceLocation(location));
        }
    };
};

export default reduxForm({ form: formName, validate })(
    connect(mapStateToProps, mapDispatchToProps)(ImageSourceLocationForm)
);


// WEBPACK FOOTER //
// ./src/components/imaging/ImageSourceLocationPage/ImageSourceLocationForm.jsx